import React from 'react'

const DeviceTab = () => {
  return (
    <div>DeviceTab</div>
  )
}

export default DeviceTab